var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.dynamicClasses},_vm._l((this.data),function(filter){return _c('span',{key:filter.oid,staticClass:"ml-2 mr-2",attrs:{"separator":false}},[_c('nna-button-filter',{nativeOn:{"click":function($event){return _vm.onFilter(filter)}}},[_vm._v(_vm._s(filter.name))])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0495cd1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/common/components/products/productsFilter.vue
// module id = null
// module chunks = 